angular.module('rjmNg.services').factory 'systemSummaryService', [
  '$http',
  '$url',
  'app',
  '$q',
  ($http, $url, app, $q) ->

    baseUrl = $url("/client/#{app.getClientId()}/systemsummary")
    cache = {}

    do_get = (suffix) ->
      deferred = $q.defer()
      if cache[suffix]?
        deferred.resolve cache[suffix]
      else
        $http
          method: 'GET'
          url: baseUrl + suffix
        .then ({data}) ->
          cache[suffix] = angular.copy data
          deferred.resolve data
        .catch () ->
          deferred.reject()
      return deferred.promise

    metrics: () ->
      do_get('/metrics')

    filtersets: () ->
      do_get('/filtersets')

    dimensions: () ->
      do_get('/dimensions')

]
